import React, { useRef } from "react";
import Footer from "../layout/Footer";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import Intro from "../components/Home/Product/Intro";
import DescriptionHome from "../components/Home/Product/DescriptionHome";
import DescriptionHome2 from "../components/Home/Product/DescriptionHome2";
import TakeControl from "../components/Home/Product/TakeControl";
import ProjectsDescription from "../components/Home/Product/ProjectsDescription";
import FeedDescription from "../components/Home/Product/FeedDescription";
import DataSecurity from "../components/Home/DataSecurity";
import Extras from "../components/Home/Product/Extras";




const Home = () => {

gsap.registerPlugin(ScrollTrigger);
const container = useRef()
const sectionRef = useRef()

useGSAP(() => {
  let mm = gsap.matchMedia();
  mm.add("(min-width: 784px)", () =>{
    gsap.fromTo(sectionRef.current, {
      translateX: 0
    },{
      translateX: "-300vw",
      ease: 'none',
      duration: 1,
      scrollTrigger:{
        trigger: container.current,
        start: "top top",
        end: "3000 top",
        pin: true,
        scrub: true,
        // markers: true,
      }
    })
    
  })


}, {scope: container, revertOnUpdate: true})



  return (
    <div className="overflow-x-hidden">

    <div className="w-full flex flex-col items-center justify-center  py-12 px-4 sm:px-6 lg:px-8 bg-[#353535]">
      <div className="w-full space-y-[60px] lg:space-y-40">
      <Intro />
      <DescriptionHome />
      <DescriptionHome2 />
        
        <section className="overflow-hidden">
        <div ref={container}>
        <div ref={sectionRef} className="flex flex-col md:flex-row">

        <div className="lg:w-screen lg:flex-shrink-0">
        <TakeControl />
        </div>
        <div className="lg:w-screen lg:flex-shrink-0">
        <ProjectsDescription />
        </div>
        <div className="lg:w-screen lg:flex-shrink-0">
        <FeedDescription />
        </div>
        <div className="lg:w-screen lg:flex-shrink-0">
        <DataSecurity />
        </div>

        </div>
        </div>
        </section>
          
      <Extras />
      </div>
    </div>
      <Footer/>
    </div>
  );
};

export default Home;
